import { hasEntity, decodeHtmlEntities } from "../components/InteractiveRichText/InteractiveRichText";
import { useGetPolicyBodyText } from "@coherehealth/core-platform-api";

interface UsePolicyBodyHtmlResult {
  html: string;
  loading: boolean;
  error: string | null;
}

const htmlCache = new Map<string, string>();

export function useGetPolicyBodyHtml(sectionId: string): UsePolicyBodyHtmlResult {
  const { data, loading, error } = useGetPolicyBodyText({
    queryParams: { policySectionId: sectionId },
  });

  const raw: string = data?.docs?.[0]?.text ?? "";
  const html = raw ? (hasEntity(raw) ? decodeHtmlEntities(raw) : raw) : "";

  if (html) {
    htmlCache.set(sectionId, html);
  }

  return {
    html: htmlCache.get(sectionId) ?? html,
    loading: loading && !htmlCache.has(sectionId),
    error: error ? String(error) : null,
  };
}
